import { assign } from 'xstate';

import { type BundleMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Drops the highlighted product when the selection modal is dismissed.
 */
export const clearPendingProduct: BundleMachineAction = assign(() => ({
  pendingProduct: undefined,
}));
